module.exports = __webpack_public_path__ + "static/media/netshoes-logo].0eaa6dec.png";